import { render, staticRenderFns } from "./Paysolutions.vue?vue&type=template&id=08e29c71&scoped=true&"
import script from "./Paysolutions.vue?vue&type=script&lang=js&"
export * from "./Paysolutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e29c71",
  null
  
)

export default component.exports